import {
  ByIdPayload,
  FailByIdPayload,
  OperationReducerTypes,
  PayloadAction,
  uniqueActionType
} from '@industi/ngx-common';

export const DictionaryOperationDeleteActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[dictionary/operation] Delete'),
  requestFail: uniqueActionType('[dictionary/operation] Delete fail'),
  requestSuccess: uniqueActionType('[dictionary/operation] Delete success'),
  requestClearErrors: uniqueActionType('[dictionary/operation] Delete clear errors'),
  requestClear: uniqueActionType('[dictionary/operation] Delete clear')
};

export class DictionaryOperationDeleteAction implements PayloadAction {
  readonly type = DictionaryOperationDeleteActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryOperationDeleteFailAction implements PayloadAction {
  readonly type = DictionaryOperationDeleteActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class DictionaryOperationDeleteSuccessAction implements PayloadAction {
  readonly type = DictionaryOperationDeleteActionTypes.requestSuccess;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryOperationDeleteClearErrorsAction implements PayloadAction {
  readonly type = DictionaryOperationDeleteActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryOperationDeleteClearAction implements PayloadAction {
  readonly type = DictionaryOperationDeleteActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
